export default __webpack_public_path__ + "cbd17d20167f433754811973ab1b64db.png";